import React, { useState, useEffect } from 'react';
import { Grid, Snackbar, Typography, Alert, AlertTitle } from '@mui/material';
import theme from './theme/theme';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AppNavbar from './Componentes/Navegacion/AppNavbar';
import { useStateValue } from './Contexto/store';
import DiccionarioEtiquetas from './Configuracion/Idiomas/Etiquetas_Diccionario';
import { obtenerUsuarioActual } from './Actions/Usuarios/UsuarioAction';
import RutaSegura from './Componentes/Navegacion/RutaSegura';
import Config from './Configuracion/Configuraciones';
import RutasComponente from './Configuracion/RutaComponentes';
import AsignaIdomaEtiquetas, { obtenerMensajeIdiomaCodigo } from './Actions/Generales/IdiomasAction';
import IdleTimeOutHandler from './Componentes/ManejoSesion/IdleTimeOutHandler';
/*
import BackGround1024 from './Activos/Imagenes/BannerHome/BannerCS_1024x576_px.jpg';
import BackGround1366 from './Activos/Imagenes/BannerHome/BannerCS_1366x768_px.jpg';
import BackGround1440 from './Activos/Imagenes/BannerHome/BannerCS_1440x810_px.jpg';
import BackGround1536 from './Activos/Imagenes/BannerHome/BannerCS_1536x864_px.jpg';
import BackGround1920 from './Activos/Imagenes/BannerHome/BannerCS_1920X1080_px.jpg';
*/
import LogoBannerClass from './Activos/Imagenes/BannerHome/LogoBannerClass.svg';
import ImgInnovasoftFooter from './Activos/Imagenes/ImgInnovasoftFooter.svg';
/*import ImgLimitlessFooter from './Activos/Imagenes/ImgLimitlessFooter.svg';*/

import useMediaQuery from '@mui/material/useMediaQuery';
import { styleApp, /*styleAppBackGroundNew, styleAppBackGrounds*/ } from './Componentes/Tool/Style';
import { MyDialog } from './Componentes/ControlUsuario/Cargando';
//import { getWindowDimensions } from './Utilidades/DimensionesPantalla';
import Encabezado from './Componentes/ControlUsuario/Encabezado/Encabezado';

import './theme/cssReactToastNotifications/react-toast-notificatons.css';
import { useToasts } from 'react-toast-notifications';
import useFirstRender from './Utilidades/useFirstRender';


function App() {

    const { addToast } = useToasts();
    const firstRender = useFirstRender()

    /*const dimensionPantalla = getWindowDimensions();
    const BackGround = ((dimensionPantalla.width === null) ? BackGround1920 :
        ((dimensionPantalla.width <= 1024) ? BackGround1024 :
            (((dimensionPantalla.width <= 1366) ? BackGround1366 :
                (((dimensionPantalla.width <= 1440) ? BackGround1440 :
                    ((dimensionPantalla.width <= 1536) ? BackGround1536 : BackGround1920)))))));

    const BackGroundHeight = ((dimensionPantalla.width === null) ? 200 :
        ((dimensionPantalla.width <= 1024) ? 130 :
            (((dimensionPantalla.width <= 1366) ? 164 : (((dimensionPantalla.width <= 1440) ? 164 :
                ((dimensionPantalla.width <= 1536) ? 164 : 164)))))));

    const AlturaLogoBanner = (BackGroundHeight / 2) - (55 / 2);*/

    //console.log(dimensionPantalla, BackGround);

    //Estilo
    //const classBackGroung = styleAppBackGround();
    /*const classBackGroungNew = styleAppBackGroundNew();*/

    const ImagenMovil = useMediaQuery(theme.breakpoints.down('sm'));

    const [{ sesionUsuario, autorizacion, openSnackbar, etiquetasIdioma, compania }, dispatch] = useStateValue();

    const [iniciaApp, setIniciaApp] = useState(false);

    /*const [showLogo, setShowLogo] = useState(false);*/

    const [positionSnackBar, setPositionSnackBar] = React.useState({
        vertical: 'bottom',
        horizontal: 'center',
    });

    const { vertical, horizontal } = positionSnackBar;

    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    const [autorizaUsuario, setAutorizaUsuario] = useState({
        Rutas: RutasComponente.Rutas,
        RutaLogin: RutasComponente.RutaLogin,
        RutaHome: RutasComponente.RutaHome,
        RutaNotFound: RutasComponente.RutaNotFound,
        RutaRecorevyPassword: RutasComponente.RutaRecorevyPassword,
        RutaRecorevyPasswordSussed: RutasComponente.RutaRecorevyPasswordSussed,
        RutaChangePassword: RutasComponente.RutaChangePassword,
        Modulo: RutasComponente.Modulo
    });

    useEffect(() => {
        //Se toma el idioma del LocalStorage de no estar definido devuelve nulo.
        const etiIdioma = window.localStorage.getItem("etiqueta_idioma");
        obtenerUsuarioActual(etiIdioma, dispatch)
            .then((response) => {
                setIniciaApp(true);

            })
            .catch((error) => {
                setIniciaApp(true);
            });

        // Se realiza la asignacion del idioma a las etiquetas de los componentes cuando el app se inicio
        //La variable etiIdioma de ser nula devuelve el idioma por defecto que es ES
        AsignaIdomaEtiquetas(etiIdioma, dispatch);
    }, []);

    useEffect(() => {
        // se valida el set del objeto que maneja la ruta para determinar si es por el archivo de rutas o del reducer 
        let autorizacionUsuario = autorizacion ? autorizacion : RutasComponente; // se extrae la navegacion del reducer  
        // En caso de ser nulo se dejan las rutas del archivo de rutas inicial que esta todo como denegado
        // caso contrario lo toma del reducer de rutas 

        // se llama al dispatch para que como tal se actualice el reducer
        setAutorizaUsuario({
            Rutas: autorizacionUsuario.Rutas,
            RutaLogin: autorizacionUsuario.RutaLogin,
            RutaHome: autorizacionUsuario.RutaHome,
            RutaNotFound: autorizacionUsuario.RutaNotFound,
            RutaRecorevyPassword: autorizacionUsuario.RutaRecorevyPassword,
            RutaRecorevyPasswordSussed: autorizacionUsuario.RutaRecorevyPasswordSussed,
            RutaChangePassword: autorizacionUsuario.RutaChangePassword,
            Modulo: autorizacionUsuario.Modulo
        });
    }, [autorizacion]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        dispatch({
            type: "OPEN_SNACKBAR",
            openMensaje: {
                open: false,
                severity: '',
                mensaje: [""]
            },
        });
    };

    useEffect(() => {
        if (firstRender) {
            return
        }

        if (openSnackbar !== undefined) {
            if (openSnackbar.open) {
                const listadoMensajes = openSnackbar.mensaje;
                listadoMensajes.forEach(function (codigo) {
                    addToast(obtenerMensajeIdiomaCodigo(etiquetasIdioma.CodigoIdioma, codigo).mensaje, { appearance: openSnackbar.severity });
                });
            }
        }
    }, [openSnackbar]);

    //const sectionStyleBanner = {
    //    backgroundImage:
    //        `url(${BackGround})`,
    //    padding: '0px 80px',
    //    height: BackGroundHeight + 'px'
    //};

    /*const sectionStyleBannerDesktopNew = {
        backgroundImage:
            `url(${BackGround})`,
        padding: '0px 40px',
        height: BackGroundHeight + 'px'
    };

    const sectionStyleBannerMovilNew = {
        backgroundImage:
            `url(${BackGround})`,
        padding: '10px 40px',
        height: BackGroundHeight + 'px'
    };*/

    return iniciaApp === false ? null : (
        <React.Fragment>
            {/*             <Snackbar open={openSnackbar ? openSnackbar.open : false} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleClose} severity={openSnackbar.severity}>
                    {Object.values(openSnackbar.mensaje).length > 1 ? <AlertTitle>{obtenerMensajeIdiomaCodigo(etiquetasIdioma.CodigoIdioma, openSnackbar.severity).mensaje}</AlertTitle> : null}
                    {openSnackbar.mensaje.map((codigo) => (<React.Fragment key={codigo}> <Typography variant='body'>{obtenerMensajeIdiomaCodigo(etiquetasIdioma.CodigoIdioma, codigo).mensaje}</Typography><br /></React.Fragment>))}
                </Alert>  
            </Snackbar> */}
            <MyDialog />
            <Router>
                <IdleTimeOutHandler />
                <AppNavbar />
                <div style={sesionUsuario?.autenticado ? styleApp.divBackGroundAutenticado : styleApp.divBackGround}>
                
                    <Encabezado LogoBanner={((compania?.LogoLimitless === 'S' && ImagenMovil === false) || (compania?.LogoLimitlessMovil === 'S' && ImagenMovil)) 
                    ? LogoBannerClass : null } TextoBanner={etiquetas.EtiquetasComponente.Home.Et_HomeTitulo} />


                    {/*
                        (((ImagenMovil ? compania?.CfgImgBGMovil : compania?.CfgImgBGDesktop) !== "") ?
                            <img alt="..." src={ImagenMovil ? compania?.CfgImgBGMovil : compania?.CfgImgBGDesktop} style={{
                                width: '100%'
                            }} />
                            :
                            //<div className={ImagenMovil ? classBackGroung.Movil : classBackGroung.Desktop} style={sectionStyleBanner} >
                            //    <div style={ImagenMovil ? styleApp.logoBackGroundMovil : styleApp.logoBackGroundDesktop} >
                            //        <img alt="..." src={LogoBannerClass} style={{
                            //            display: ((compania?.LogoLimitless === 'S' && ImagenMovil === false) || (compania?.LogoLimitlessMovil === 'S' && ImagenMovil))
                            //                ? 'inline' : 'none', marginTop: (AlturaLogoBanner < 0) ? 0 : AlturaLogoBanner
                            //        }} />
                            //    </div>
                            //</div>
                            <div className={classBackGroungNew.MovilAndDesktop} style={ImagenMovil ? sectionStyleBannerMovilNew : sectionStyleBannerDesktopNew} >
                                <div style={ImagenMovil ? styleApp.logoBackGroundMovilNew : styleApp.logoBackGroundDesktopNew} >
                                    <img alt="..." src={LogoBannerClass} style={{
                                        display: ((compania?.LogoLimitless === 'S' && ImagenMovil === false) || (compania?.LogoLimitlessMovil === 'S' && ImagenMovil))
                                            ? 'inline' : 'none'/*, marginTop: (AlturaLogoBanner < 0) ? 0 : AlturaLogoBanner*//*
                                    }} />
                                    <Typography variant='h5' style={ImagenMovil ? styleApp.textoBackGroundMovilNew : styleApp.textoBackGroundDesktopNew}>
                                        {etiquetas.EtiquetasComponente.Home.Et_HomeTitulo}
                                    </Typography>
                                </div>
                            </div>
                        )
                    */}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', minHeight: sesionUsuario?.autenticado ? 'calc(100vh - 50px)' : '100vh' }}>
                    <div style={{ display: 'flex', flexGrow: '1' }} >
                        <Grid container
                    /*style={sesionUsuario?.autenticado ? styleApp.DivAppGeneralAutenticado : styleApp.DivAppGeneral}*/>
                            <Switch>

                                <Route exact path={Config.rutaPublicacion + autorizaUsuario.RutaLogin.path} component={autorizaUsuario.RutaLogin.component} />
                                <Route exact path={Config.rutaPublicacion + autorizaUsuario.RutaNotFound.path} component={autorizaUsuario.RutaNotFound.component} />
                                <Route exact path={Config.rutaPublicacion + autorizaUsuario.RutaRecorevyPassword.path} component={autorizaUsuario.RutaRecorevyPassword.component} />
                                <Route exact path={Config.rutaPublicacion + autorizaUsuario.RutaRecorevyPasswordSussed.path} component={autorizaUsuario.RutaRecorevyPasswordSussed.component} />
                                <Route exact path={Config.rutaPublicacion + autorizaUsuario.RutaChangePassword.path} component={autorizaUsuario.RutaChangePassword.component} />
                                <RutaSegura exact path={Config.rutaPublicacion + autorizaUsuario.RutaHome.path} component={autorizaUsuario.RutaHome.component} />

                                {

                                    autorizaUsuario.Rutas.map(({ path, disabled, component, opt }, key) => <RutaSegura exact path={Config.rutaPublicacion + path} component={disabled === false ? component : autorizaUsuario.RutaNotFound.component} key={key} />)

                                }

                                <RutaSegura exact path={Config.rutaPublicacion + "/"} component={autorizaUsuario.RutaLogin.component} />

                            </Switch>
                        </Grid>
                    </div>
                    {sesionUsuario?.autenticado === true ?
                        <div style={{ display: 'flex', alignItems: 'center', height: '40px', padding: '0px 40px', backgroundColor: '#F5F5F5' }} >
                            <Typography variant='caption'
                                style={{ fontWeight: 400, fontSize: '8px', fontFamily: 'roboto', lineHeight: '8px', color: '#919999' }} >
                                {etiquetas.EtiquetasComponente.Home.Et_TituloFooter}
                            </Typography>
                            <img alt="..." src={ImgInnovasoftFooter} style={{ height: '22px', marginLeft: 'auto' }} />
                        </div>
                        : null}
                </div>
            </Router>
        </React.Fragment>
    );
}

export default App;